export default __webpack_public_path__ + "static/media/img_card.b9b3cea5.png";